import * as types from "./actionTypes"

const initialState = {
    allUserViews: [],
    recentlyUpdatedOrCreated: false,
    toggleViewMangerNotification: {
        status: "",
        show: false,
        message: "",
    },
}

export default function userViewReducer(state = initialState, action) {
    switch (action.type) {
        case types.USER_VIEWS_DETAILS_FETCH_SUCCESS:
            return {
                ...state,
                allUserViews: action.payload,
            }
        case types.USER_VIEW_CREATED_OR_UPDATED_RECENTLY:
            return {
                ...state,
                recentlyUpdatedOrCreated: action.payload,
            }

        case types.USER_VIEWS_SAVE_SUCCESS:
            return {
                ...state,
                allUserViews: [...state.allUserViews, action.payload],
            }
        case types.USER_VIEWS_UPDATE_SUCCESS:
            return {
                ...state,
                allUserViews: [...state.allUserViews].map((view) =>
                    //Replace Existing view with updated View
                    view.name === action.payload.name ? action.payload : view
                ),
            }
        case types.USER_VIEW_CLEAR_ALL:
            return {
                ...initialState,
            }
        case types.TOGGLE_VIEW_MANAGER_NOTIFICATION:
            return {
                ...state,
                toggleViewMangerNotification: action.payload,
            }
        default:
            return state
    }
}
